

import React, { useEffect, useState } from 'react';
import styles from '../../assets/scss/InventoryManagement/InventoryTable.module.scss';
import { FaChevronDown, FaChevronUp, FaEdit, FaEllipsisV, FaTrashAlt } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import {
    useGetInventoryItemsQuery,
    useGetItemcatQuery,
    useUpdateInventoryStockMutation,
    useUpdateItemPriceMutation
} from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import { createPortal } from 'react-dom';
import PriceCategory from './PriceCategory';
import DeleteConfirmModalLogout from '../../Components/Common/DeleteConfirmModalLogout';
import PreBookedOrders from './PreBookedOrders';
import { capitalize } from '../../utils/capitalize';

const InventoryTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [dropdownIndex, setDropdownIndex] = useState(null);
    const [buyingPrice, setBuyingPrice] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [showStats, setShowStats] = useState(false);
    // const [activeTab, setActiveTab] = useState('overview');
    const [editingItemId, setEditingItemId] = useState(null);
    const [dropdownAnchor, setDropdownAnchor] = useState({ top: null, bottom: null, left: 0 });


    const [updateInventoryStock, { isLoading: isUpdatingStock }] = useUpdateInventoryStockMutation();


    const [searchParams, setSearchParams] = useSearchParams();

    const activeTab = searchParams.get("tab") || "overview";

    const setActiveTab = (tab) => {
        setSearchParams({ tab }); // updates URL ?tab=price or ?tab=overview
    };

    const [updateItemPrice] = useUpdateItemPriceMutation();
    const navigate = useNavigate();
    const offset = currentPage;

    const { data: catData } = useGetItemcatQuery();

    const { data, isLoading } = useGetInventoryItemsQuery({
        fromDate: fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : undefined,
        toDate: toDate ? dayjs(toDate).format('YYYY-MM-DD') : undefined,
        category: selectedCategory,
        search,
        offset,
        limit,
    });

    console.log(data, "inventorydata0000000");



    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [selectedStockItem, setSelectedStockItem] = useState(null);


    //  console.log(data,"data98476498");


    useEffect(() => {
        setCurrentPage(1);
    }, [selectedCategory, search, fromDate, toDate]);

    const totalPages = Math.ceil((data?.total || 0) / limit);

    const handleCreateItem = () => navigate('/dashboard/AddNewItems');

    const toggleDropdown = (index) => {
        setDropdownIndex(prev => (prev === index ? null : index));
    };

    const closeDropdown = () => {
        setDropdownIndex(null);
    };

    useEffect(() => {
        const handleClickOutside = () => closeDropdown();
        window.addEventListener("click", handleClickOutside);
        return () => window.removeEventListener("click", handleClickOutside);
    }, []);

    return (
        <div className={styles.inventoryContainer}>
            <div className={styles.orderContainers}>


                <div className={styles.tabHeader}>
                    <div className={styles.dflex}>
                        {/* <button
                            className={`${styles.tabButton} ${activeTab === 'overview' ? styles.active : ''}`}
                            onClick={() => setActiveTab('overview')}
                        >
                            Inventory Overview
                        </button>
                        <button
                            className={`${styles.tabButton} ${activeTab === 'price' ? styles.active : ''}`}
                            onClick={() => setActiveTab('price')}
                        >
                            Update Over All Price
                        </button> */}
                        <button
                            className={`${styles.tabButton} ${activeTab === 'overview' ? styles.active : ''}`}
                            onClick={() => setActiveTab('overview')}
                        >
                            Inventory Items List & Buying
                        </button>

                        <button
                            className={`${styles.tabButton} ${activeTab === 'price' ? styles.active : ''}`}
                            onClick={() => setActiveTab('price')}
                        >
                            Update the overall price for item category
                        </button>

                        <button
                            className={`${styles.tabButton} ${activeTab === 'prebooked' ? styles.active : ''}`}
                            onClick={() => setActiveTab('prebooked')}
                        >
                            Items for Pre-booked orders
                        </button>


                    </div>


                    <div className={styles.statsHeader}>
                        <button
                            className={styles.collapseBtn}
                            onClick={() => setShowStats(prev => !prev)}
                        >
                            {showStats ? (
                                <FaChevronUp className={styles.collapseBtnicon} />
                            ) : (
                                <FaChevronDown className={styles.collapseBtnicon} />
                            )}
                        </button>
                    </div>


                    {/* <button
                        className={`${styles.tabButton} ${activeTab === 'price' ? styles.active : ''}`}
                        onClick={() => {
                            setActiveTab('price');
                            navigate('/dashboard/PriceCategory');
                        }}
                    >
                        Price Category
                    </button> */}

                </div>

                {activeTab === 'overview' && showStats && (
                    <>
                        {/* <h3 className={styles.margintop}>Inventory Overview</h3> */}
                        <div className={styles.summarySection}>
                            <div className={styles.summaryBox}>
                                <h4 className={styles.margin}>Categories</h4>
                                <h2 className={styles.marginnum}>{data?.categoryCount || 0}</h2>
                                <p className={styles.marginday}>Current Month</p>
                            </div>
                            <div className={styles.summaryBoxs}>
                                <h4 className={styles.margin}>Total Products</h4>
                                <h2 className={styles.marginnum}>{data?.total || 0}</h2>
                                <p className={styles.marginday}>Current Month</p>
                            </div>
                        </div>
                    </>
                )}

                {/* {activeTab === 'price' && showStats && (
                    <div> <h1>heelo</h1>
                        <div className={styles.tabContent}>
                            <h3 className={styles.margintop}>Update Categories Price</h3>
                            
                            <PriceCategory />
                        </div></div>

                )} */}

                {activeTab === 'price' && (
                    <div>
                        {showStats && <div>
                            {/* <h3 className={styles.margintop}>Update Categories Price</h3> */}
                            {/* <Link to="/dashboard/PriceCategory" className={styles.linkWrapper}>
                            <div className={styles.summaryBoxschild}>
                                <h4 className={styles.margin}>Click to View/Update Prices</h4>
                                <h2 className={styles.marginnum}>{data?.categoryCount || 0}</h2>
                                <p className={styles.marginday}>Current Month</p>
                            </div>
                        </Link> */}</div>}

                        <div className={styles.tabContent}>
                            <PriceCategory />
                        </div>
                    </div>
                )}

            </div>

            {activeTab === 'overview' && (
                <>
                    {/* Filters */}
                    <div className={styles.filterInputs}>
                        <input
                            className={styles.searchInput}
                            placeholder="Search here..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <select
                            className={styles.inputs}
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                        >
                            <option value="">Item Categories</option>
                            {catData?.getAllItems?.map((item) => (
                                <option key={item._id} value={item.itemCategory}>
                                    {item.itemCategory.charAt(0).toUpperCase() + item.itemCategory.slice(1)}
                                </option>
                            ))}
                        </select>

                        <DatePicker
                            selected={fromDate}
                            onChange={(date) => setFromDate(date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="From Date"
                            maxDate={new Date()}
                            isClearable
                            className={styles.inputss}
                        />

                        <DatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="To Date"
                            maxDate={new Date()}
                            isClearable
                            className={styles.inputss}
                        />

                        <button className={styles.clearBtn} onClick={() => {
                            setSearch('');
                            setFromDate(null);
                            setToDate(null);
                            setSelectedCategory('');
                            setCurrentPage(1);
                        }}>
                            Clear All
                        </button>

                        <button className={styles.addButton} onClick={handleCreateItem}>
                            + Buy Items                        </button>
                    </div>

                    {/* Table */}
                    <div className={styles.tableWrapper}>
                        <div className={styles.tableScroll}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Inventory <br /> ID</th>
                                        <th>Invoice <br /> ID</th>
                                        <th>Item <br /> ID</th>
                                        <th>Item <br /> Owner</th>
                                        <th>Org <br /> Name</th>
                                        <th>Date</th>
                                        <th>Phone <br /> Number</th>
                                        <th>Item <br /> Category</th>
                                        <th>Quantity</th>
                                        <th>Quality</th>
                                        <th>Commission Type</th>
                                        <th> Buying <br /> Price</th>
                                        <th>Selling <br /> Price</th>
                                        <th>Handle By</th>
                                        <th>Set Price</th>
                                        <th>Stock</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {isLoading ? (
                                        <tr><td colSpan="12">Loading...</td></tr>
                                    ) : !data?.items || data.items.length === 0 ? (
                                        <tr><td colSpan="12" className={styles.noData}>No items found</td></tr>
                                    ) : (
                                        data.items.map((item, index) => (
                                            <tr key={item._id}>
                                                <td className="notranslate">{item.inventory?.inventoryId || '-'}</td>
                                                {/* <td>{item.invoice[0]?.invoiceNumber || '-'}</td> */}
                                                <td className="notranslate">
                                                    {item?.invoice?.length > 0
                                                        ? item.invoice[0]?.invoiceNumber
                                                        : item?.inventory?.invoiceId
                                                            ? `#${item.inventory.invoiceId.slice(-4)}`
                                                            : '-'}
                                                </td>

                                                <td className="notranslate">{item.itemId || '-'}</td>
                                                <td>{item.farmer?.firstName ? capitalize(item.farmer.firstName) : '-'}</td>
                                                <td>{item.farmer?.storeName ? capitalize(item.farmer.storeName) : '-'}</td>
                                                <td>{item.createdAt ? dayjs(item.createdAt).format('DD/MM/YYYY') : '-'}</td>
                                                <td className="notranslate">{item.farmer?.phone || '-'}</td>
                                                <td>{item.productName ? capitalize(item.productName) : '-'}</td>
                                                {/* <td>
                                                {item.productBag === 'kilogram'
                                                    ? `${item.productQuantity || 0} kg`
                                                    : `${item.productCount || 0} sacks`}
                                            </td> */}
                                                <td className="notranslate">{item?.overallQuantity} kg</td>
                                                <td>{item.productQuality ? capitalize(item.productQuality) : '-'}</td>
                                                <td>{item?.inventory?.saleCommission ? capitalize(item.inventory.saleCommission) : '-'}</td>
                                                <td className="notranslate">{item.buyingPrice ? `₹${item.buyingPrice}` : '₹-'}</td>
                                                <td className="notranslate">{item.sellingPrice ? `₹${item.sellingPrice}` : '₹-'}</td>
                                                <td>
                                                    {item.handleBy?.firstName
                                                        ? capitalize(item.handleBy.firstName)
                                                        : '-'}
                                                </td>
                                                <td className={styles.actionCell}>
                                                    <div className={styles.dropdownWrapper}>
                                                        <button
                                                            className={styles.dropdownToggle}
                                                            onClick={(e) => {
                                                                const rect = e.currentTarget.getBoundingClientRect();
                                                                let top = null;
                                                                let bottom = null;
                                                                // If it's one of the last 5 items, open it upwards from the button's top
                                                                if (index >= data.items.length - 5 && data.items.length > 5) {
                                                                    bottom = window.innerHeight - rect.top + 8;
                                                                } else {
                                                                    // Otherwise open it downwards from the button's bottom
                                                                    top = rect.bottom + 8;
                                                                }

                                                                setDropdownAnchor({
                                                                    top,
                                                                    bottom,
                                                                    left: rect.left - 140, // Adjusted to better align with the now 180px width
                                                                });
                                                                e.stopPropagation();
                                                                toggleDropdown(index);
                                                                setEditingItemId(item._id);
                                                                setBuyingPrice(item.buyingPrice || '');
                                                                setSellingPrice(item.sellingPrice || '');
                                                            }}
                                                        >
                                                            {/* <FaEllipsisV /> */}
                                                            {/* <button className={styles.addButtonstock}>Edit Price</button> */}
                                                            <button
                                                                className={` ${item.buyingPrice && item.sellingPrice
                                                                    ? styles.editBtnGreen
                                                                    : styles.editBtnRed
                                                                    }`}
                                                            >
                                                                Set/Edit Price
                                                            </button>

                                                        </button>

                                                        {dropdownIndex === index && createPortal(
                                                            <div
                                                                className={styles.portalMenu}
                                                                style={{
                                                                    top: dropdownAnchor.top !== null ? `${dropdownAnchor.top}px` : 'auto',
                                                                    bottom: dropdownAnchor.bottom !== null ? `${dropdownAnchor.bottom}px` : 'auto',
                                                                    left: `${dropdownAnchor.left}px`,
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div className={styles.dropdownHeader}>
                                                                    <span>Edit Price Details</span>
                                                                    <FaEdit className={styles.editIcon} />
                                                                </div>

                                                                <div className={styles.inputGroup}>
                                                                    <label>Buying Price</label>
                                                                    <div className={styles.inputWithIcon}>
                                                                        {/* <input
                                                                        type="number"
                                                                        value={buyingPrice}
                                                                        onChange={(e) => setBuyingPrice(e.target.value)}
                                                                    /> */}
                                                                        <input
                                                                            type="number"
                                                                            value={buyingPrice}
                                                                            min={0}
                                                                            onChange={(e) => setBuyingPrice(e.target.value)}
                                                                        />
                                                                        <FaTrashAlt
                                                                            className={styles.trashIcon}
                                                                            onClick={() => setBuyingPrice('')}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className={styles.inputGroup}>
                                                                    <label>Selling Price</label>
                                                                    <div className={styles.inputWithIcon}>
                                                                        {/* <input
                                                                        type="number"
                                                                        value={sellingPrice}
                                                                        onChange={(e) => setSellingPrice(e.target.value)}
                                                                    /> */}
                                                                        <input
                                                                            type="number"
                                                                            value={sellingPrice}
                                                                            min={buyingPrice || 0}
                                                                            onChange={(e) => setSellingPrice(e.target.value)}
                                                                        />
                                                                        <FaTrashAlt
                                                                            className={styles.trashIcon}
                                                                            onClick={() => setSellingPrice('')}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {/* <button
                                                                className={styles.saveBtn}
                                                                onClick={async () => {
                                                                    if (!editingItemId || !buyingPrice || !sellingPrice) {
                                                                        toast.warn('Please enter both prices');
                                                                        return;
                                                                    }

                                                                    try {
                                                                        await updateItemPrice({
                                                                            itemId: editingItemId,
                                                                            buyingPrice: Number(buyingPrice),
                                                                            sellingPrice: Number(sellingPrice),
                                                                        }).unwrap();

                                                                        toast.success('Price updated successfully');
                                                                        closeDropdown();
                                                                    } catch (err) {
                                                                        console.error('Update failed:', err);
                                                                        toast.error('Failed to update price');
                                                                    }
                                                                }}
                                                            >
                                                                Save
                                                            </button> */}
                                                                <button
                                                                    className={styles.saveBtn}
                                                                    onClick={async () => {
                                                                        if (!editingItemId || !buyingPrice || !sellingPrice) {
                                                                            toast.warn('Please enter both prices');
                                                                            return;
                                                                        }

                                                                        const buying = Number(buyingPrice);
                                                                        const selling = Number(sellingPrice);

                                                                        if (selling < buying) {
                                                                            toast.warn("Selling price must be greater than or equal to Buying price");
                                                                            return;
                                                                        }

                                                                        try {
                                                                            await updateItemPrice({
                                                                                itemId: editingItemId,
                                                                                buyingPrice: buying,
                                                                                sellingPrice: selling,
                                                                            }).unwrap();

                                                                            toast.success("Price updated successfully");
                                                                            closeDropdown();
                                                                        } catch (err) {
                                                                            console.error("Update failed:", err);
                                                                            toast.error("Failed to update price");
                                                                        }
                                                                    }}
                                                                >
                                                                    Save
                                                                </button>

                                                            </div>,
                                                            document.body
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {/* <button
                                                        className={styles.addButtonstock}
                                                        disabled={isUpdatingStock}
                                                        onClick={async () => {
                                                            try {
                                                                const response = await updateInventoryStock(item?._id).unwrap();
                                                                toast.success(response?.message || "Stock status updated");
                                                            } catch (err) {
                                                                console.error(err);
                                                                toast.error("Failed to update stock");
                                                            }
                                                        }}
                                                    >
                                                        {isUpdatingStock ? "Updating..." : "Stock"}
                                                    </button> */}
                                                        <button
                                                            className={styles.addButtonstock}
                                                            onClick={() => {
                                                                setSelectedStockItem(item); // store selected item
                                                                setConfirmModalOpen(true);  // open confirmation modal
                                                            }}
                                                        >
                                                            Mark as out of stock
                                                        </button>

                                                    </div>
                                                </td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>

                    {/* Pagination */}
                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </>
            )}


            {activeTab === 'prebooked' && (
                <div className={styles.tabContent}>
                    <PreBookedOrders />
                </div>
            )}

            <DeleteConfirmModalLogout
                isOpen={confirmModalOpen}
                onConfirm={async () => {
                    try {
                        if (!selectedStockItem?._id) return;
                        const response = await updateInventoryStock(selectedStockItem._id).unwrap();
                        toast.success(response?.message || "Stock status updated successfully");
                    } catch (error) {
                        console.error(error);
                        toast.error("Failed to update stock");
                    } finally {
                        setConfirmModalOpen(false);
                        setSelectedStockItem(null);
                    }
                }}
                onCancel={() => setConfirmModalOpen(false)}
                title="Confirm the item stock count update"
                heading="Update the Inventory Item"
                content={
                    selectedStockItem ? (
                        <>
                            <p><strong>Product Name:</strong> {selectedStockItem?.productName ? capitalize(selectedStockItem.productName) : "-"}</p>
                            <p><strong>Owner Name:</strong> {selectedStockItem?.farmer?.firstName ? capitalize(selectedStockItem.farmer.firstName) : "-"}</p>
                            <p><strong>Quantity:</strong> {selectedStockItem?.overallQuantity || 0} kg</p>
                            <p>Would you like to update the Inventory Item out of stock?</p>
                        </>

                    ) : (
                        <p>Loading item details...</p>
                    )
                }
            />

        </div>
    );
};

export default InventoryTable;




